import { Icons } from '@/assets'
import { ROUTES } from '@/constants/routes'
import type { FC, SVGProps } from 'react';

export interface NavItemConfig {
  id: string
  icon: FC<SVGProps<SVGSVGElement>>;
  label: string
  path: string
}

export const MAIN_MENU: NavItemConfig[] = [
  { id: 'builder', icon: Icons.BuilderIcon, label: "Builder", path: ROUTES.MAIN.BUILDER },
  { id: 'project-compliance', icon: Icons.ProjectComplianceIcon, label: "Project Compliance", path: ROUTES.MAIN.PROJECTCOMPLIANCE },
  { id: 'buyer', icon: Icons.BuyerIcon, label: "Buyer", path: ROUTES.MAIN.BUYER },
  { id: 'broker', icon: Icons.BrokerIcon, label: "Broker", path: ROUTES.MAIN.BROKER },
];

export const BOTTOM_MENU: NavItemConfig[] = [];
